import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueTour from 'vue-tour';
import VPopover from 'vue-js-popover';
import config from '@/config.js';

require('vue-tour/dist/vue-tour.css');

/*import Api from "@/lib/Api";*/
Vue.$api = Vue.prototype.$api = {
  config: config.getEnv(),
  user: null,
};

import Alert from "@/lib/Alert";
Vue.$alert = Vue.prototype.$alert = Alert;

import Notification from "@/lib/Notification";
Vue.$notification = Vue.prototype.$notification = Notification;

Vue.config.productionTip = false;

import {mask} from 'vue-the-mask';
Vue.directive('mask', mask);

Vue.use(VueTour);
Vue.use(VPopover, { tooltip: true })

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');